import { render, staticRenderFns } from "./ClosingReasonsDoughnutChart.vue?vue&type=template&id=21dd447c&scoped=true&"
import script from "./ClosingReasonsDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsDoughnutChart.vue?vue&type=style&index=0&id=21dd447c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd447c",
  null
  
)

export default component.exports